module.exports = function() {
  return new Worker(__webpack_public_path__ + "5a37c5576263b1ee24da.worker.js");
};